export const screenSizes = {
    xsmall: 550,
    small: 700,
    medium: 800,
    large: 1100
}